export interface Snapshots {
  [description: string]: { [index: number]: string };
}
